var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getURLParam, handlise } from '../helpers/urlHelpers';
// Create a list of all vaid url params
export const getPossibleParams = (components, prefix) => {
    const possibleParams = [];
    components.forEach((component) => {
        component.products.forEach((product) => {
            if (product.inner_parts) {
                product.inner_parts.products.forEach((innerProduct) => {
                    possibleParams.push(`${prefix}${component.name}--${product.part_type}--${innerProduct.part_type}`);
                });
            }
            else {
                possibleParams.push(`${prefix}${component.name}--${product.part_type}`);
            }
        });
    });
    return possibleParams;
};
// Get all available variants for a component
export const extractVariants = (componentData) => {
    const allVariants = [];
    function extractFromComponent(products) {
        products.forEach((product) => {
            if (product.variants && product.variants.length > 1) {
                return allVariants.push(product.variants);
            }
            if (product.inner_parts) {
                return extractFromComponent(product.inner_parts.products);
            }
        });
    }
    componentData.forEach((component) => {
        extractFromComponent(component.products);
    });
    return allVariants;
};
export const extractImagesFromComponent = (products, productHandle) => {
    const allVariants = [];
    function extractImages(prods, handle) {
        prods.forEach((product) => {
            if (product.inner_parts) {
                return extractImages(product.inner_parts.products, handle);
            }
            else if (product.variants) {
                product.variants.forEach((variant) => {
                    allVariants.push(Object.assign(Object.assign({}, variant), { component: product.part_type, parentProduct: handle }));
                });
            }
        });
    }
    extractImages(products, productHandle);
    return allVariants;
};
// Get all images from the bundle
export const extractImages = (components, productHandle) => {
    const allImages = [];
    components.forEach((component) => {
        let variantImages = [];
        variantImages = extractImagesFromComponent(component.products, productHandle);
        allImages.push(variantImages);
    });
    const flattened = allImages.flat();
    const grouped = groupByComponent(flattened);
    return grouped;
};
export const extractDataFromComponent = (currentComp, products, compIndex, baseIndex) => {
    const allVariants = [];
    function extractImages(comp, prods, useIndex) {
        prods.forEach((product, index) => {
            const currentProduct = comp.find((prod) => prod.part == product.part_type);
            const monogramming = product.monogramming;
            let emojis = null;
            if (monogramming && monogramming.emojis) {
                emojis = monogramming.emojis.filter((emoji) => emoji.selected);
            }
            const monogramming_back = product.monogramming_back;
            let emojis_back = null;
            if (monogramming_back && monogramming_back.emojis) {
                emojis_back = monogramming_back.emojis.filter((emoji) => emoji.selected);
            }
            if (product.inner_parts) {
                return extractImages(comp, product.inner_parts.products, true);
            }
            else if (product.variants) {
                product.variants.forEach((variant) => {
                    let selected = false;
                    if (currentProduct && currentProduct.selectedVariant == variant) {
                        selected = true;
                    }
                    allVariants.push({
                        component: product.part_type,
                        selected: selected,
                        placement: monogramming.placement,
                        monogramming: monogramming.value,
                        monogramming_back: monogramming_back.value,
                        additional_image: monogramming_back === null || monogramming_back === void 0 ? void 0 : monogramming_back.additional_image,
                        emojis: emojis,
                        emojis_back: emojis_back,
                        prodIndex: useIndex ? index : 0,
                        compIndex: compIndex,
                        baseIndex: baseIndex,
                    });
                });
            }
        });
    }
    extractImages(currentComp, products, false);
    return allVariants;
};
export const generateDynamicDataForImages = (currentBundleItem, components, baseIndex) => {
    const alldata = [];
    components.forEach((component, compIndex) => {
        let variantImages = [];
        const currentComp = currentBundleItem[component.name];
        variantImages = extractDataFromComponent(currentComp, component.products, compIndex, baseIndex);
        alldata.push(variantImages);
    });
    const flattened = alldata.flat();
    const grouped = groupByComponent(flattened);
    return grouped;
};
const groupByComponent = (data) => {
    return data.reduce((acc, item) => {
        const component = item.component;
        if (!acc[component]) {
            acc[component] = [];
        }
        acc[component].push(item);
        return acc;
    }, {});
};
// Find a selected variants by colour swatch
export const findVariantByColourName = (components, colourName, currentBundle) => {
    const selectedVariants = {};
    components.forEach((component) => {
        selectedVariants[handlise(component.name)] = [];
        const currentProduct = currentBundle[component.name][0].product;
        const featuredProduct = component.products.find((product) => product.part_type == currentProduct || product.part_type == currentBundle[component.name][0].part);
        if (featuredProduct.inner_parts) {
            featuredProduct.inner_parts.products.forEach((innerProduct) => {
                let found = false;
                // Find the selected colour variant
                innerProduct.variants.forEach((innerVariant) => {
                    if (!found && innerVariant.colour_swatch && innerVariant.colour_swatch.name == colourName) {
                        selectedVariants[component.name].push({
                            selectedVariant: innerVariant,
                            product: featuredProduct.part_type,
                            component: component.name,
                            part: innerProduct.part_type,
                            otherVariants: innerProduct.variants,
                            title: innerProduct.title,
                            part_title: innerProduct.part_title,
                            monogramming: innerProduct.monogramming,
                            monogramming_back: innerProduct.monogramming_back,
                        });
                        found = true;
                    }
                });
                // If it's not found, return the current colour
                if (!found) {
                    if (innerProduct.variants.length == 1) {
                        selectedVariants[component.name].push({
                            selectedVariant: innerProduct.variants[0],
                            product: featuredProduct.part_type,
                            component: component.name,
                            part: innerProduct.part_type,
                            otherVariants: innerProduct.variants,
                            title: innerProduct.title,
                            part_title: innerProduct.part_title,
                            monogramming: innerProduct.monogramming,
                            monogramming_back: innerProduct.monogramming_back,
                        });
                    }
                    else {
                        const currentBundleProduct = currentBundle[component.name].find((bundleProd) => bundleProd.part == innerProduct.part_type);
                        selectedVariants[component.name].push({
                            selectedVariant: currentBundleProduct.selectedVariant,
                            product: featuredProduct.part_type,
                            component: component.name,
                            part: innerProduct.part_type,
                            otherVariants: innerProduct.variants,
                            title: innerProduct.title,
                            part_title: innerProduct.part_title,
                            monogramming: innerProduct.monogramming,
                            monogramming_back: innerProduct.monogramming_back,
                        });
                    }
                }
            });
        }
        else {
            let found = false;
            featuredProduct.variants.forEach((innerVariant) => {
                if (!found && innerVariant.colour_swatch && innerVariant.colour_swatch.name == colourName) {
                    selectedVariants[component.name].push({
                        selectedVariant: innerVariant,
                        product: featuredProduct.part_type,
                        component: component.name,
                        part: featuredProduct.part_type,
                        otherVariants: featuredProduct.variants,
                        title: featuredProduct.title,
                        part_title: featuredProduct.part_title,
                        monogramming: featuredProduct.monogramming,
                        monogramming_back: featuredProduct.monogramming_back,
                    });
                    found = true;
                }
            });
            if (!found) {
                if (featuredProduct.variants.length == 1) {
                    selectedVariants[component.name].push({
                        selectedVariant: featuredProduct.variants[0],
                        product: featuredProduct.part_type,
                        component: component.name,
                        part: featuredProduct.part_type,
                        otherVariants: featuredProduct.variants,
                        title: featuredProduct.title,
                        part_title: featuredProduct.part_title,
                        monogramming: featuredProduct.monogramming,
                        monogramming_back: featuredProduct.monogramming_back,
                    });
                }
                else {
                    const currentBundleProduct = currentBundle[component.name].find((bundleProd) => bundleProd.part == featuredProduct.part_type);
                    selectedVariants[component.name].push({
                        selectedVariant: currentBundleProduct.selectedVariant,
                        product: featuredProduct.part_type,
                        component: component.name,
                        part: featuredProduct.part_type,
                        otherVariants: featuredProduct.variants,
                        title: featuredProduct.title,
                        part_title: featuredProduct.part_title,
                        monogramming: featuredProduct.monogramming,
                        monogramming_back: featuredProduct.monogramming_back,
                    });
                }
            }
        }
        if (selectedVariants[component.name].length === 0) {
            selectedVariants[component.name].push(currentBundle[component.name][0]);
        }
    });
    return selectedVariants;
};
// Find common colours for all components
export const findCommonColourSwatches = (variantArrays) => {
    // Find the longest array of variants
    const longestArray = variantArrays.reduce((max, arr) => (arr.length > max.length ? arr : max), []);
    // Extract all colour_swatch objects from the longest array as the initial set
    let commonColourSwatches = longestArray.filter((variant) => variant.colour_swatch !== null && variant.colour_swatch.exclude_in_solid_colours != true).map((variant) => (Object.assign(Object.assign({}, variant.colour_swatch), { available: variant.available })));
    // Compare with the rest of the arrays
    for (const variants of variantArrays) {
        if (variants.length > 1 && variants !== longestArray) {
            const currentColourSwatches = variants.filter((variant) => variant.colour_swatch !== null && variant.colour_swatch.exclude_in_solid_colours != true).map((variant) => (Object.assign(Object.assign({}, variant.colour_swatch), { available: variant.available })));
            if (currentColourSwatches.length > 0) {
                commonColourSwatches = commonColourSwatches.filter((colourSwatch) => currentColourSwatches.some((currentColourSwatch) => currentColourSwatch.name === colourSwatch.name));
                commonColourSwatches = commonColourSwatches.map((colourSwatch) => {
                    const currentSwatch = currentColourSwatches.find((swatch) => swatch.name == colourSwatch.name);
                    if (currentSwatch.available == false) {
                        return currentSwatch;
                    }
                    else {
                        return colourSwatch;
                    }
                });
            }
        }
    }
    return commonColourSwatches;
};
// Find all colours for all components
export const findAllColourSwatches = (variantArrays) => {
    const colourSwatches = new Map();
    variantArrays.forEach((group) => {
        group.forEach((item) => {
            const swatch = item.colour_swatch;
            swatch['available'] = item.available;
            if (swatch) {
                const colorKey = swatch.color || swatch.name;
                if (!colourSwatches.has(colorKey)) {
                    colourSwatches.set(colorKey, swatch);
                }
            }
        });
    });
    return Array.from(colourSwatches.values());
};
// Find first available variant in a component
export const findFirstAvailableVariants = (components) => {
    const selectedVariants = {};
    components.forEach((component) => {
        selectedVariants[handlise(component.name)] = [];
        const featuredProduct = component.products[0];
        if (featuredProduct.inner_parts) {
            featuredProduct.inner_parts.products.forEach((innerProduct) => {
                let found = false;
                innerProduct.variants.forEach((innerVariant) => {
                    if (!found && innerVariant.available) {
                        selectedVariants[component.name].push({
                            selectedVariant: innerVariant,
                            product: featuredProduct.part_type,
                            component: component.name,
                            part: innerProduct.part_type,
                            otherVariants: innerProduct.variants,
                            title: innerProduct.title,
                            part_title: innerProduct.part_title,
                            monogramming: innerProduct.monogramming,
                            monogramming_back: innerProduct.monogramming_back,
                        });
                        found = true;
                    }
                });
                if (!found) {
                    const selectedVariant = innerProduct.variants[0];
                    selectedVariants[component.name].push({
                        selectedVariant: selectedVariant,
                        product: featuredProduct.part_type,
                        component: component.name,
                        part: innerProduct.part_type,
                        otherVariants: innerProduct.variants,
                        title: innerProduct.title,
                        part_title: innerProduct.part_title,
                        monogramming: innerProduct.monogramming,
                        monogramming_back: innerProduct.monogramming_back,
                    });
                }
            });
        }
        else {
            let found = false;
            featuredProduct.variants.forEach((innerVariant) => {
                if (!found && innerVariant.available) {
                    selectedVariants[component.name].push({
                        selectedVariant: innerVariant,
                        product: featuredProduct.part_type,
                        component: component.name,
                        part: featuredProduct.part_type,
                        otherVariants: featuredProduct.variants,
                        title: featuredProduct.title,
                        part_title: featuredProduct.part_title,
                        monogramming: featuredProduct.monogramming,
                        monogramming_back: featuredProduct.monogramming_back,
                        productOptions: featuredProduct.product_options,
                    });
                    found = true;
                }
            });
            if (!found) {
                selectedVariants[component.name].push({
                    selectedVariant: featuredProduct.variants[0],
                    product: featuredProduct.part_type,
                    component: component.name,
                    part: featuredProduct.part_type,
                    otherVariants: featuredProduct.variants,
                    title: featuredProduct.title,
                    part_title: featuredProduct.part_title,
                    monogramming: featuredProduct.monogramming,
                    monogramming_back: featuredProduct.monogramming_back,
                });
            }
        }
        if (selectedVariants[component.name].length === 0) {
            delete selectedVariants[component.name];
        }
    });
    return selectedVariants;
};
// Get random variant
export const findRandomVariants = (currentBundle) => {
    const updatedBundle = {};
    const getRandomAvailableVariantExcludingCurrent = (variants, currentId) => {
        let availableVariants = variants;
        if (variants.length > 1) {
            availableVariants = variants.filter((variant) => variant.available && variant.id !== currentId);
        }
        if (availableVariants.length === 0) {
            // If no other variants are available, fallback to the current one
            return variants.find((v) => v.id === currentId);
        }
        return availableVariants[Math.floor(Math.random() * availableVariants.length)];
    };
    // Iterate over each component in the current bundle (like base, lid, etc.)
    Object.keys(currentBundle).forEach((componentName) => {
        updatedBundle[componentName] = [];
        currentBundle[componentName].forEach((partInfo) => {
            const { selectedVariant, otherVariants } = partInfo, rest = __rest(partInfo, ["selectedVariant", "otherVariants"]);
            const newRandomVariant = getRandomAvailableVariantExcludingCurrent(otherVariants, selectedVariant.id);
            updatedBundle[componentName].push(Object.assign({ selectedVariant: newRandomVariant, otherVariants }, rest));
        });
    });
    return updatedBundle;
};
// Find selected variant in a component  by default parts
export const findSelectedVariants = (components, defaultParts) => {
    const selectedVariants = {};
    const defaultGroups = defaultParts.filter((dp) => dp.part_type.includes('base') || dp.part_type.includes('hull'));
    const otherDefaultParts = defaultParts.filter((dp) => dp.part_type.includes('base') == false && dp.part_type.includes('hull') == false);
    defaultGroups.forEach((defaultPart) => {
        const selectedType = defaultPart.part_type;
        const selectedComponent = components.find((component) => {
            return component.products.find((product) => { var _a; return product.part_type == selectedType || ((_a = product.inner_parts) === null || _a === void 0 ? void 0 : _a.products.some((innerPart) => innerPart.part_type == selectedType)); });
        });
        const selectedProduct = selectedComponent === null || selectedComponent === void 0 ? void 0 : selectedComponent.products.find((part) => { var _a; return part.part_type == selectedType || ((_a = part.inner_parts) === null || _a === void 0 ? void 0 : _a.products.some((innerPart) => innerPart.part_type == selectedType)); });
        if (selectedProduct) {
            selectedVariants[selectedComponent.name] = [];
            if (selectedProduct.inner_parts) {
                const selectedPart = selectedProduct.inner_parts.products.find((elem) => elem.part_type === selectedType);
                const selectedVariant = selectedPart.variants.find((elem) => elem.id === defaultPart.id);
                selectedVariants[selectedComponent.name].push({
                    selectedVariant: selectedVariant,
                    product: selectedProduct.part_type,
                    component: selectedComponent.name,
                    part: selectedPart.part_type,
                    otherVariants: selectedPart.variants,
                    title: selectedProduct.title,
                    part_title: selectedProduct.part_title,
                    monogramming: selectedProduct.monogramming,
                    monogramming_back: selectedProduct.monogramming_back,
                });
                if (otherDefaultParts.length < defaultGroups.length) {
                    otherDefaultParts.forEach((otherDefaultPart) => {
                        const otherSelectedType = otherDefaultPart.part_type;
                        const otherSelectedPart = selectedProduct.inner_parts.products.find((elem) => elem.part_type === otherSelectedType);
                        if (otherSelectedPart) {
                            const otherSelectedVariant = otherSelectedPart.variants.find((elem) => elem.id === otherDefaultPart.id);
                            selectedVariants[selectedComponent.name].push({
                                selectedVariant: otherSelectedVariant,
                                product: selectedProduct.part_type,
                                component: selectedComponent.name,
                                part: otherSelectedPart.part_type,
                                otherVariants: otherSelectedPart.variants,
                                title: otherSelectedPart.title,
                                part_title: otherSelectedPart.part_title,
                                monogramming: otherSelectedPart.monogramming,
                                monogramming_back: otherSelectedPart.monogramming_back,
                            });
                        }
                    });
                }
                if (selectedProduct.inner_parts.products.length > selectedVariants[selectedComponent.name].length) {
                    const missingParts = selectedProduct.inner_parts.products.filter((elem) => !selectedVariants[selectedComponent.name].find((inner) => inner.part == elem.part_type));
                    missingParts.forEach((missingPart) => {
                        const availableVariant = missingPart.variants.find((elem) => elem.available) || missingPart.variants[0];
                        selectedVariants[selectedComponent.name].push({
                            selectedVariant: availableVariant,
                            product: selectedProduct.part_type,
                            component: selectedComponent.name,
                            part: missingPart.part_type,
                            otherVariants: missingPart.variants,
                            title: missingPart.title,
                            part_title: missingPart.part_title,
                            monogramming: selectedProduct.monogramming,
                            monogramming_back: selectedProduct.monogramming_back,
                        });
                    });
                }
            }
            else {
                const selectedVariant = selectedProduct.variants.find((elem) => elem.id === defaultPart.id);
                selectedVariants[selectedComponent.name].push({
                    selectedVariant: selectedVariant,
                    product: selectedProduct.part_type,
                    component: selectedComponent.name,
                    part: selectedProduct.part_type,
                    otherVariants: selectedProduct.variants,
                    title: selectedProduct.title,
                    part_title: selectedProduct.part_title,
                    monogramming: selectedProduct.monogramming,
                    monogramming_back: selectedProduct.monogramming_back,
                });
            }
        }
    });
    return selectedVariants;
};
// Find variants from URL params
export const getVariantsFromURL = (queryParams, components, prodIndex) => {
    const variants = {};
    // Loop through each component
    components.forEach((component) => {
        // Initialize the component array in the result object
        if (!variants[component.name]) {
            variants[component.name] = [];
        }
        let foundProduct = null;
        component.products.forEach((product) => {
            // Check if the product has inner parts or variants directly
            if (foundProduct)
                return;
            if (product.inner_parts) {
                product.inner_parts.products.forEach((innerProduct) => {
                    const paramName = `${prodIndex + 1}--${component.name}--${product.part_type}--${innerProduct.part_type}`;
                    const paramId = queryParams.get(paramName);
                    // Check if that paramName is in the URL
                    if (paramId) {
                        let foundVariant = null;
                        foundProduct = product;
                        // Check if that variant exists
                        innerProduct.variants.forEach((variant) => {
                            if (String(variant.id) === paramId) {
                                foundVariant = variant;
                            }
                        });
                        // If not, replace it with the first available
                        if (!foundVariant) {
                            foundVariant = innerProduct.variants.find((variant) => variant.available) || innerProduct.variants[0];
                        }
                        variants[component.name].push({
                            selectedVariant: foundVariant,
                            product: product.part_type,
                            component: component.name,
                            part: innerProduct.part_type,
                            otherVariants: innerProduct.variants,
                            title: innerProduct.title,
                            part_title: innerProduct.part_title,
                            monogramming: innerProduct.monogramming,
                            monogramming_back: innerProduct.monogramming_back,
                        });
                    }
                });
            }
            else {
                // Does not have inner parts
                const paramName = `${prodIndex + 1}--${component.name}--${product.part_type}`;
                const paramId = queryParams.get(paramName);
                const preselectedVariant = queryParams.get('variant');
                if (paramId || preselectedVariant) {
                    let foundVariant = null;
                    product.variants.forEach((variant) => {
                        // Check if that variant exists
                        if (String(variant.id) === paramId || String(variant.id) === preselectedVariant) {
                            foundVariant = variant;
                            foundProduct = product;
                        }
                    });
                    // If not, replace it with the first available
                    if (!foundVariant) {
                        foundVariant = product.variants.find((variant) => variant.available) || product.variants[0];
                        foundProduct = product;
                    }
                    variants[component.name].push({
                        selectedVariant: foundVariant,
                        product: product.part_type,
                        component: component.name,
                        part: product.part_type,
                        otherVariants: product.variants,
                        title: product.title,
                        part_title: product.part_title,
                        monogramming: product.monogramming,
                        monogramming_back: product.monogramming_back,
                        productOptions: product.product_options,
                    });
                }
            }
        });
    });
    // Check if the component is missing elements
    for (const component in variants) {
        if (variants[component].length) {
            const compName = variants[component][0].component;
            const prodName = variants[component][0].product;
            const partName = variants[component][0].part;
            // Find the current component
            const productOptions = components.find((innerComp) => innerComp.name == compName);
            // If the component has different product options, find the current product
            if (productOptions) {
                const innerProductOptions = productOptions.products.find((innerProd) => innerProd.part_type == prodName || innerProd.part_type == partName);
                if (innerProductOptions.inner_parts) {
                    innerProductOptions.inner_parts.products.forEach((innerPart) => {
                        const paramName = `${prodIndex + 1}--${component}--${prodName}--${innerPart.part_type}`;
                        const paramId = getURLParam(paramName);
                        if (!paramId) {
                            const firstAvailable = innerPart.variants.find((variant) => variant.available) || innerPart.variants[0];
                            variants[component].push({
                                selectedVariant: firstAvailable,
                                product: prodName,
                                component: compName,
                                part: innerPart.part_type,
                                otherVariants: innerPart.variants,
                                title: innerPart.title,
                                part_title: innerPart.part_title,
                                monogramming: innerPart.monogramming,
                                monogramming_back: innerPart.monogramming_back,
                            });
                        }
                    });
                }
            }
        }
        else {
            const productOptions = components.find((innerComp) => innerComp.name == component);
            const featuredProduct = productOptions.products[0];
            if (featuredProduct.inner_parts) {
                featuredProduct.inner_parts.products.forEach((innerProduct) => {
                    let found = false;
                    innerProduct.variants.forEach((innerVariant) => {
                        if (!found && innerVariant.available) {
                            variants[component].push({
                                selectedVariant: innerVariant,
                                product: featuredProduct.part_type,
                                component: component,
                                part: innerProduct.part_type,
                                otherVariants: innerProduct.variants,
                                title: innerProduct.title,
                                part_title: innerProduct.part_title,
                                monogramming: innerProduct.monogramming,
                                monogramming_back: innerProduct.monogramming_back,
                            });
                            found = true;
                        }
                    });
                    if (!found) {
                        variants[component].push({
                            selectedVariant: innerProduct.variants[0],
                            product: featuredProduct.part_type,
                            component: component,
                            part: innerProduct.part_type,
                            otherVariants: innerProduct.variants,
                            title: innerProduct.title,
                            part_title: innerProduct.part_title,
                            monogramming: innerProduct.monogramming,
                            monogramming_back: innerProduct.monogramming_back,
                        });
                    }
                });
            }
            else {
                let found = false;
                featuredProduct.variants.forEach((innerVariant) => {
                    if (!found && innerVariant.available) {
                        variants[component].push({
                            selectedVariant: innerVariant,
                            product: featuredProduct.part_type,
                            component: component,
                            part: featuredProduct.part_type,
                            otherVariants: featuredProduct.variants,
                            title: featuredProduct.title,
                            part_title: featuredProduct.part_title,
                            monogramming: featuredProduct.monogramming,
                            monogramming_back: featuredProduct.monogramming_back,
                        });
                        found = true;
                    }
                });
                if (!found) {
                    variants[component].push({
                        selectedVariant: featuredProduct.variants[0],
                        product: featuredProduct.part_type,
                        component: component,
                        part: featuredProduct.part_type,
                        otherVariants: featuredProduct.variants,
                        title: featuredProduct.title,
                        part_title: featuredProduct.part_title,
                        monogramming: featuredProduct.monogramming,
                        monogramming_back: featuredProduct.monogramming_back,
                    });
                }
            }
        }
    }
    return variants;
};
// Map variants as URL params
export const mapComponentVariants = (currentBundleItems) => {
    const result = {};
    const mapItems = (componentObject, prefix) => {
        for (const component in componentObject) {
            if (Array.isArray(componentObject[component])) {
                if (componentObject[component].length > 1) {
                    componentObject[component].forEach((item) => {
                        const key = `${prefix}${component}--${item.product}--${item.part}`;
                        result[key] = item.selectedVariant.id;
                    });
                }
                else {
                    componentObject[component].forEach((item) => {
                        const key = `${prefix}${component}--${item.part}`;
                        result[key] = item.selectedVariant.id;
                    });
                }
            }
        }
    };
    currentBundleItems.forEach((bundleProd, index) => {
        mapItems(bundleProd, `${index + 1}--`);
    });
    return result;
};
export const convertToTitleCase = (str) => {
    return str
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};
export const cleanPriceLabel = (priceStr) => {
    const num = parseFloat(priceStr);
    return num % 1 === 0 ? parseInt(priceStr, 10) : num;
};
export const checkShopifyFile = (filename, region) => __awaiter(void 0, void 0, void 0, function* () {
    const endpoint = 'https://c4xg2svfll.execute-api.ap-southeast-2.amazonaws.com/default/fgShopifyFileCheck';
    const url = `${endpoint}?filename=${encodeURIComponent(filename)}&region=${region}`;
    // console.log('FG retrieving file:', filename);
    try {
        const response = yield fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error(`API error: ${response.status}`);
        }
        const data = yield response.json();
        // data.url will be the file's URL if found, or false if not found
        return data.url;
    }
    catch (err) {
        console.error('Error calling Shopify file check Lambda:', err);
        return false;
    }
});
